/**
 *
 *Our _get implementation differs from lodash/pydash a bit.
 *
 * if we went the lodash route
 *
 * _get(quickshop, 'product.id')
 *
 * in the templates would fail if quickshop was undefined.
 *
 * so we've opted to go with
 *
 * _get('quickshop.product.id')
 *
 * and read straight from the context. this avoid something like
 * {% if quickshop and _get(quickshop, 'product.id') %}
 *
 */
export function _get(path, args) {
    const defaultValue = _.get(args, 'default', '') || args || '';

    return _.get(this.ctx, path, defaultValue);
}

export function _getFromObj(obj, path, args) {
    const defaultValue = _.get(args, 'default', '') || args || '';

    return _.get(obj, path, defaultValue);
}
